import React, { useRef } from "react";
import Avatar from "@mui/material/Avatar";
import { resignContactPicture } from "../../helpers/resignMedia";

// FASE4-PASO6a (ronda de seguridad de /public): Contact.urlPicture ahora
// es una URL firmada que vence (bloques de 6h). Mismo patron de retry-once
// ya probado en el paso 5 (MessagesList) -- un ref con los contactId ya
// reintentados + mutacion directa de e.target.src, nunca estado de React,
// para que el reintento funcione aunque la firma re-emitida sea un string
// identico al actual (mismo bloque de 6h). contact puede venir undefined
// durante la primera carga de varias pantallas -- no hace nada en ese caso.
const ContactAvatar = ({ contact, ...avatarProps }) => {
	const retriedRef = useRef(new Set());

	const handleError = async (e) => {
		if (!contact?.id || retriedRef.current.has(contact.id)) return;
		retriedRef.current.add(contact.id);
		const freshUrl = await resignContactPicture(contact.id);
		if (freshUrl && e.target) e.target.src = freshUrl;
	};

	return <Avatar src={contact?.urlPicture} onError={handleError} {...avatarProps} />;
};

export default ContactAvatar;
